import { AlertEvent } from "@auradata/contracts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AlertsPage } from "@/features/alerts/AlertsPage";
import { alertsQuery } from "@/lib/api/queries";
import { projectSearch } from "@/lib/search";

const search = projectSearch.extend({
  rule: z.string().optional(),
  name: z.string().optional(),
  event: AlertEvent.optional(),
  severity: z.enum(["any", "error", "warning"]).optional(),
  jobs: z.string().optional(),
  selector: z.string().optional(),
});

export const Route = createFileRoute("/w/$workspace/p/$project/alerts")({
  validateSearch: search,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(alertsQuery(params.workspace, params.project)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <AlertsPage
        workspace={workspace}
        project={project}
        ruleId={s.rule ?? null}
        prefill={{
          name: s.name,
          event: s.event,
          severity: s.severity,
          jobs: s.jobs,
          selector: s.selector,
        }}
        onRule={(id) =>
          navigate({ search: (prev) => ({ env: prev.env, rule: id ?? undefined }), replace: true })
        }
      />
    );
  },
});
